import { Component, Input, OnInit } from "@angular/core";
import { ColumnConfig } from "../../../components/_custom-table/interface";
import { ToolsService } from "../../../services/tools.service";
import { ToastrService } from "../../../components/_toastr/toastr.service";
import { HttpService } from "../../../services/http.service";
import { DistributionAcShort } from "../../../interfaces/DistributionAc";
import { AlertDialogService } from "../../../components/_alert-dialog/alert-dialog.service";
import { Actionnaire } from "../../../interfaces/Actionnaire";

@Component({
  selector: "app-dividendes",
  templateUrl: "./dividendes.component.html",
  standalone: false,
})
export class DividendesComponent implements OnInit {
  @Input() actionnaire: Actionnaire;

  isLoading: boolean = false;
  dividendes: DistributionAcShort[] = [];

  columns: ColumnConfig[] = [
    {
      key: "distributionAC_Date",
      label: "Date",
      filter: {
        type: "date",
        format: "dd/MM/yyyy",
      },
    },
    {
      key: "distributionAC_Nature",
      label: "Nature",
      filter: { type: "text" },
    },
    {
      key: "distributionAC_Qte",
      label: "Nb Actions",
      filter: {
        type: "number",
      },
    },
    {
      key: "distributionAC_Valeur",
      label: "Net versé",
      filter: { type: "money" },
    },
    {
      key: "distributionAC_RS",
      label: "RS rés.",
      filter: { type: "money" },
    },
    {
      key: "distributionAC_PFL",
      label: "RS non rés.",
      filter: { type: "money" },
    },
  ];

  constructor(
    private _http: HttpService,
    private _toast: ToastrService,
    private _tools: ToolsService,
    private _alert: AlertDialogService
  ) {}

  ngOnInit(): void {
    this.getDividendes();
  }

  getDividendes(): void {
    this.isLoading = true;
    this._http.GET(
      "/api/distributionac",
      {
        actionnaire_ID: this.actionnaire.actionnaire_ID,
      },
      (result) => {
        if (result.isOk) {
          this.dividendes = result.obj;
          this.isLoading = false;
        } else {
          this._toast.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
        this.isLoading = false;
      },
      (error) => {
        this._tools.showHttpError(error);
        this.isLoading = false;
      }
    );
  }
}
